<template>
<div class="c-competence-cards-batch-page">
    <div class="o-width-limiter">
		<can i="manage" a="CompetenceCard">
			<div class="t-margin-bottom-m">
                <button v-if="$can('manage', 'CompetenceCard')" @click="$router.back()" class="c-button c-button--linkstyle">Tillbaka</button>
			</div>
			<competence-cards-batch-data-provider>
				<div slot-scope="dataProvider">
					<h1 v-if="!dataProvider.showBatchSuccessMessage" class="t-text-style-alpha t-margin-bottom-m">Lägg till kurs för flera medarbetare</h1>
					<div v-if="dataProvider.loading" class="c-spinner"></div>
					<template v-if="!dataProvider.loading">
						<competence-card-batch-course 
							mode="create"
							:showBatchSuccessMessage="dataProvider.showBatchSuccessMessage"
							:competence-cards="dataProvider.competenceCards" 
							:courseOptions="dataProvider.courseOptions" 
							@addCourseBatch="dataProvider.batchAddCourse"
							@closeSuccessMessage="dataProvider.toggleBatchSuccessMessage">
						</competence-card-batch-course>
					</template>
				</div>
			</competence-cards-batch-data-provider>
		</can>
        <p v-if="!$can('manage', 'CompetenceCard')" class="t-text-style-beta t-margin-bottom-s t-margin-top-s">
            För att få tillgång till IN Kompetensverktyg behöver du vara administratör av tjänsten.</br>
            Kontakta tjänsteadministratören på ditt företag om du vill se din kompetensprofil eller skriva ut ett kompetenskort.
        </p>
    </div>
</div>
</template>

<script>
import CompetenceCardsBatchDataProvider from '@/components/competences/competence-cards-batch-data-provider/CompetenceCardsBatchDataProvider.vue';
import CompetenceCardBatchCourse from '@/components/competences/competence-card-batch-course/CompetenceCardBatchCourse.vue';

export default {
    name: 'CompetenceCardsBatchPage',
    components: {
        CompetenceCardsBatchDataProvider,
        CompetenceCardBatchCourse,
    },
    props: {
        apiUrl: {
            type: String,
            default: ''
        },
    },
    data: () => ({
        path: ''
    }),
    created() {
        this.path = this.$route.path;
        this.$store.dispatch('competences/setAppData', {
            apiUrl: this.apiUrl
        }).then(() => {
            this.$store.dispatch('competences/setSettingsContext');
        });
    },
}
</script>
